
export function initPortfolio() {
    const closeButtons = document.querySelectorAll('.display-row-close');
    closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            clearActiveDisplays();
        });
    });

    const portfolioItems = document.querySelectorAll('.portfolio-item');
    for (const portfolioItem of portfolioItems) {
        // The link is for crawlers, keyboard and ctrl/middle-click; a plain click keeps opening the display row.
        // Untrusted clicks are Hummingbird replaying the click that triggered delayed script loading.
        const link = portfolioItem.querySelector('.portfolio-link');
        link?.addEventListener('click', (e) => {
            const isPointerClick = e.detail > 0 || !e.isTrusted;
            if (isPointerClick && e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) {
                e.preventDefault();
            }
        });
        portfolioItem.addEventListener('mousedown', (e) => {
            if (window.innerWidth <= 768) {
                const mobileDisplayRowIndex = portfolioItem.dataset.targetMobileDisplayRow;
                const mobileDisplayRow = document.querySelector(`[data-mobile-display-row="${mobileDisplayRowIndex}"]`)
                if (portfolioItem.classList.contains('active')) {
                    mobileDisplayRow.scrollIntoView({
                        block: "start"
                    })
                    clearActiveDisplays()
                } else {
                    if (mobileDisplayRow) {
                        clearActiveDisplays()
                        addToDisplayRow(portfolioItem, mobileDisplayRow)
                        setTimeout(() => {
                            mobileDisplayRow.classList.add('active');
                            mobileDisplayRow.scrollIntoView({
                                block: "start"
                            });
                            portfolioItem.classList.add('active');
                        }, 300);
                    }
                }
            } else {
                const displayRowIndex = portfolioItem.dataset.targetDisplayRow;
                const displayRow = document.querySelector(`[data-display-row="${displayRowIndex}"]`)
                if (portfolioItem.classList.contains('active')) {
                    portfolioItem.scrollIntoView()
                    clearActiveDisplays()
                } else {
                    if (displayRow) {
                        clearActiveDisplays()
                        addToDisplayRow(portfolioItem, displayRow)
                        setTimeout(() => {
                            displayRow.classList.add('active');
                            displayRow.scrollIntoView({
                                block: "start"
                            });
                            portfolioItem.classList.add('active');
                        }, 300);
                    }
                }
            }

        })
    }
}

function clearActiveDisplays() {
    const activePortfolioItems = document.querySelectorAll('.portfolio-item.active');
    const activeDisplayRows = document.querySelectorAll('[data-display-row].active');
    const activeMobileDisplayRows = document.querySelectorAll('[data-mobile-display-row].active');
    activeDisplayRows.forEach(displayRow => {displayRow.classList.remove('active');});
    activePortfolioItems.forEach(portfolioItem => {portfolioItem.classList.remove('active');});
    activeMobileDisplayRows.forEach(displayRow => {displayRow.classList.remove('active');});
}

function addToDisplayRow(portfolioItem, displayRow) {
    const bgImgDiv = displayRow.querySelector('.bg-img');
    bgImgDiv.style.setProperty('--bg-img-url', `url(${portfolioItem.dataset.bgImgUrl})`);
    if (portfolioItem.dataset.bgImgMobileUrl) {
        bgImgDiv.style.setProperty('--bg-img-mobile-url', `url(${portfolioItem.dataset.bgImgMobileUrl})`);
    } else {
        bgImgDiv.style.setProperty('--bg-img-mobile-url','url("")');
    }
    const video = bgImgDiv.querySelector("video");
    const playBtn = bgImgDiv.querySelector('.play-btn');
    if (portfolioItem.dataset.videoUrl) {
        bgImgDiv.classList.add('video');
        video.classList.remove('d-none');
        video.src = portfolioItem.dataset.videoUrl;
        video.poster = portfolioItem.dataset.bgImgUrl;
        playBtn.classList.remove('d-none');
        video.pause();
        video.currentTime = 0;
        playBtn.onclick = () => {
            video.play();
            playBtn.classList.add('d-none');
        };
    } else {
        bgImgDiv.classList.remove('video');
        video.classList.add('d-none');
        video.src = "";
        playBtn.classList.add('d-none');
    }
    const title = displayRow.querySelector('.portfolio-title');
    title.innerHTML = `${portfolioItem.dataset?.title?.replace(/\. /, '.<br>')}`;
    const bulletsDiv = displayRow.querySelector('.bullets-div');
    const bulletsJson = JSON.parse(portfolioItem.dataset.bullets);
    const bulletListHTML = bulletsJson.map((bullet) => {return `<li>${bullet}</li>`}).join('');
    const bulletsHTML = `<ul class="text-ozols very-special">
        ${bulletListHTML}
</ul>`
    bulletsDiv.innerHTML = bulletsHTML;
}


export function hideMobileHomePortfolio() {
    const teasers = document.querySelectorAll('.home-portfolio-row .teaser');
    teasers.forEach((teaser, index) => {
        if ([5, 4].includes(index)) {
            teaser.classList.add('d-none', 'd-md-block');
        }
    });
}